module.exports = __webpack_public_path__ + "static/media/product-list-small.3203f933.webp";